<template>
  <!--数量-->
  <div class="item-cols-num clearfix">
    <div class="select">
      <span
        class="down-btn"
        :style="{ height: eHeight + 'px', lineHeight: eHeight + 'px' }"
        @click.stop.prevent="down()"
        :class="{ 'down-disabled': Num <= 0.001 }"
      >
        <i class="el-icon-minus" />
      </span>
      <input
        type="number"
        :style="{ height: eHeight + 'px' }"
        :class="{ show: show }"
        v-model="config"
        @blur="blur()"
      />
      <span
        class="up-btn"
        :style="{ height: eHeight + 'px', lineHeight: eHeight + 'px' }"
        @click.stop.prevent="up()"
      >
        <i class="el-icon-plus" />
      </span>
    </div>
  </div>
</template>
<script>
import api from '@/modules/projectA/utils/utils';
export default {
  props: {
    num: {
      type: [Number, String],
      default: 0,
    },
    price: {
      type: [Number, String],
      default: 1,
    },
    id: {
      type: [Number, String],
    },
    checked: {
      type: [String, Boolean],
    },
    isSelect: {
      type: Number,
      default: 0,
    },
    eHeight: {
      type: Number,
      default: 20,
    },
    limit: {
      type: Number,
      default: 10000000,
    },
    itemData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    config: {
      get() {
        // console.log(this.num)
        return this.num > this.limit ? this.limit : this.num;
      },
      set(val) {
        // console.log(this.limit);
        if (val > this.limit) {
          this.$message.warning('抱歉，单次采购数量不能超过99999');
        }
        // if(!api.isNumber(val)){
        //     debugger
        //   this.$message.warning('请输入数字');
        //   return;
        // }
        //  if(Number(val) < 0.0001){
        //    this.$message.warning('超过商品单次采购最小限制，最小为0.0001');
        // }
        // if(val <= 0){
        //   val = 1
        // }
        if (val > this.limit) {
          console.log(this.limit);
          this.$message.warning(`当前库存${this.limit},采购量不能超过库存`);

          val = this.limit;
          return false;
        }
        this.$emit('update:num', val);
        let subtotal = val * this.price;
        this.Num = val;
        console.log(val);
        this.$emit('edit-num', val, this.id, this.isSelect, subtotal, this.checked, this.itemData);
      },
    },
  },
  data() {
    return {
      show: true,
      flag: true,
      Num: this.num,
      numList: [],
      // limit: 99999,
    };
  },
  methods: {
    up() {
      // if(!api.isNumber(this.Num)){
      //   this.$message.warning('请输入数字');
      //   return;
      // }
      if (this.flag && this.Num < this.limit) {
        this.ani('up');
      }
      // if (this.flag) {
      //   this.ani("up");
      // }
      return false;
    },
    down() {
      // if(!api.isNumber(this.Num)){
      //   this.$message.warning('请输入数字');
      //   return;
      // }
      if (this.flag && this.Num > 0.001) {
        this.ani('down');
      }
      return false;
    },
    blur() {
      if (!api.isNumber2(this.Num)) {
        this.$message.warning('采购量必须是小数位数小于3位的正数');
        this.Num = 0;
        this.$emit('update:num', this.Num);
        let subtotal = this.Num * this.price;
        this.$emit(
          'edit-num',
          this.Num,
          this.id,
          this.isSelect,
          subtotal,
          this.checked,
          this.itemData
        );
        return;
      }
      if (this.Num <= 0) {
        this.$message.warning('超过商品单次采购最小限制，最小为0.001。');
        this.Num = this.Num <= 0 ? 0 : Number(this.Num);
      } else {
        // this.Num =
        //   this.Num > this.limit ? parseFloat(this.limit) : parseFloat(this.Num);
        if (this.Num > this.limit) {
          this.Num = parseFloat(this.limit);
        } else {
          this.Num = parseFloat(this.Num);
        }
      }
      console.log(parseFloat(this.limit));
      console.log(parseFloat(this.Num));
      this.$emit('update:num', this.Num);
      let subtotal = this.Num * this.price;
      this.$emit(
        'edit-num',
        this.Num,
        this.id,
        this.isSelect,
        subtotal,
        this.checked,
        this.itemData
      );
    },
    ani(opera) {
      //   this.flag = false;
      //   let n = this.Num;
      //   this.numList = [n - 1, n, n + 1];
      //   let ul = this.$refs.ul;
      //   let ulStyle = ul.style;
      //   this.show = false;
      //   ulStyle.zIndex = "99";
      //   ulStyle.transition = "all .2s ease-out";
      this.Num = this.num;
      if (!api.isNumber(this.Num)) {
        this.$message.warning('请输入数字');
        return;
      }
      if (opera === 'up') {
        this.Num++;
        this.Num = Math.round(this.Num * 1000) / 1000;
        this.$emit('update:num', this.Num);
        // ulStyle.transform = "translateY(-54px)";
      } else {
        this.Num--;
        this.Num = Math.round(this.Num * 1000) / 1000;
        this.$emit('update:num', this.Num);
        // ulStyle.transform = `translateY(-18px)`;
      }
      //   ul.addEventListener("transitionend", () => {
      //     this.show = true;
      //     this.domInt(ulStyle);
      //     this.flag = true;
      //   });
      //   ul.addEventListener("webkitAnimationEnd", () => {
      //     this.show = true;
      //     this.domInt(ulStyle);
      //     this.flag = true;
      //   });
      // this.num = this.Num;
      let subtotal = this.Num * this.price;
      this.Num = Math.round(this.Num * 1000) / 1000;
      console.log(this.Num);
      this.$emit(
        'edit-num',
        this.Num,
        this.id,
        this.isSelect,
        subtotal,
        this.checked,
        this.itemData
      );
    },
    domInt(domStyle) {
      domStyle.zIndex = '1';
      domStyle.transition = 'all 0s';
      domStyle.transform = 'translateY(-36px)'; // 回到原位
    },
  },
};
</script>
<style lang="scss" scoped>
.select {
  background: #ffffff;
  border: 1px solid #e6e1db;
  //   border-radius: 3px;
  font-size: 0;
  line-height: 1;
  input {
    // z-index: 10;
    // width: 36px;
    // height: 18px;
    // background-color: #fff;
    // border: none;
    // text-align: center;
    // line-height: 18px;
    // font-size: 14px;
    // padding: 0;
    // color: #666;
    // visibility: hidden;
    // position: relative;
    // border: none;
    float: left;
    width: 40px;
    // border-top: 1px solid #cccccc;
    // border-bottom: 1px solid #cccccc;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #222222;
    &.show {
      visibility: visible;
    }
  }
  ul {
    padding: 0;
    line-height: 18px;
    font-size: 14px;
    display: inline-block;
    position: absolute;
    left: 0;
    list-style: none;
    width: 36px;
    font-family: system-ui;
    z-index: 1;
    transform: translateY(-36px);
  }
  .up.up-disabled,
  .up.up-disabled:hover {
    background-position: 0 -240px !important;
    cursor: not-allowed !important;
  }
  .down-btn {
    float: left;
    width: 37px;
    background: #f2f2f2;
    // border-radius: 3px 0px 0px 3px;
    color: #bbb;
    display: inline-block;
    /*line-height: 40px;*/
    text-align: center;
    font-size: 12px;
    cursor: pointer;
    user-select: none;
    font-weight: 500;
    border-right: 1px solid #e6e1d8;
    &:hover {
      color: #fff;
      background: #126edf;
    }
  }
  .up-btn {
    display: inline-block;
    width: 37px;
    background: #f2f2f2;
    /*border-radius: 0px 3px 3px 0px;*/
    color: #222222;
    /*line-height: 40px;*/
    text-align: center;
    font-size: 12px;
    cursor: pointer;
    user-select: none;
    font-weight: 500;
    border-left: 1px solid #e6e1d8;
    &:hover {
      color: #fff;
      background: #126edf;
    }
  }
}

/*数量*/
.item-cols-num {
  display: inline-block;
}

.select {
  //   height: 40px;
  //   padding-top: 4px;
  input {
    // width: 100%;
    text-align: center;
  }
  .down {
    background-position: 0 -60px;
  }
  .down.down-disabled:hover {
    background-position: 0 -300px;
    cursor: not-allowed;
  }
  .down,
  .up {
    //   background: url(../../static/images/cart-updown_8303731e15@2x.jpg) no-repeat;

    background: #f2f2f2;
    overflow: hidden;
    float: left;
    width: 24px;
    height: 24px;
    border-radius: 3px;
    background-size: 100% auto;
    line-height: 40px;
    text-indent: -9999em;
    cursor: pointer;
    user-select: none;
  }
  .num {
    position: relative;
    overflow: hidden;
    text-align: center;
    float: left;
    width: 50px;
    height: 24px;
    // margin: 7px 0 0;
    border: none;
    border-radius: 3px;
    // line-height: 18px;
    text-align: center;
    font-size: 14px;
    border-top: 1px solid #bbbbbb;
    border-bottom: 1px solid #bbbbbb;
  }
  .up {
    margin: 0;
    background-position: 0 0;
    &:hover {
      background-position: 0 -120px;
    }
  }
  .down {
    background-position: 0 -60px;
    &:hover {
      background-position: 0 -180px;
    }
  }
}

.down.down-disabled {
  background-position: 0 -300px;
  cursor: not-allowed;
}
.num-input {
  height: 24px;
  width: 50px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  border-top: 1px solid #bbbbbb;
  border-bottom: 1px solid #bbbbbb;
}
</style>
